import axios from 'axios';
import setAPIURL from './setAPIURL'

const service = axios.create({
  baseURL: setAPIURL(process.env.APP_ENV),
  timeout: 5000
});

export function setAuthorizationToken(token) {
  if (token) {
    service.defaults.headers.common.Authorization = `${token}`;
  } else {
    delete service.defaults.headers.common.Authorization;
  }
}

export default service;
